import { Component, Input, OnChanges, ChangeDetectionStrategy, inject } from '@angular/core';
import {ApiService} from "../../services/api.service";
import {User} from "../../interfaces/user";
import {ToastService} from "../../services/toast.service";
import { KazInputComponent } from '../kaz-input/kaz-input.component';
import { KazButtonComponent } from '../kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazInputComponent, KazButtonComponent]
})
export class SettingsComponent implements OnChanges {
  private _api = inject(ApiService);
  private _toast = inject(ToastService);

  @Input() profile: User | null = null;
  phone: string = "";

  async ngOnChanges() {
    if(this.profile){
      this.phone = this.profile.phone;
    }
  }

  async updateSettings() {
    try {
      if (this.profile !== null && this.phone !== this.profile.phone) {
        this.profile.phone = this.phone;
        const data = await this._api.updateWebUser(this.profile);
        if (data) {
         this.profile = data;
          this._toast.showToast(null,"erfolgreich aktualisiert 🥳");
        }
      }
    } catch(err) {
      console.log(err);
    }
  }
}
